import { Breadcrumb as AntdBreadcrumb } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb: React.FC = () => {
  const { Item } = AntdBreadcrumb;
  const { t } = useTranslation();
  const [showBreadcrumb, setShowBreadcrumb] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setShowBreadcrumb(location.pathname.startsWith('/vehicle'));
  }, [location]);

  return showBreadcrumb ? (
    <AntdBreadcrumb>
      <Item>
        <Link to="/">{t('HOME')}</Link>
      </Item>
      <Item>{t('VEHICLE__DETAILS')}</Item>
    </AntdBreadcrumb>
  ) : null;
};

export { Breadcrumb };
